import React from 'react';
import { func, shape, string, arrayOf, bool } from 'prop-types';
import { connect } from 'react-redux';
import locationShape from 'propTypes/locationShape';
import { operations as segmentCreationOperations } from 'state/ducks/segmentCreation';
import { operations as mapOperations } from 'state/ducks/map';
import LocationMarker from 'components/Map/MapComponents/LocationMarker';

const noop = _ => _;

export function LocationMarkerGroup({
  locations,
  selectedLocations,
  selectLocation,
  deselectLocation,
  currentHover,
  enterEntity,
  leaveEntity,
  disableInteraction,
  validNextLocations,
}) {
  // eslint-disable-next-line global-require
  const { FeatureGroup } = require('react-leaflet');

  const hoveredId = currentHover && currentHover.id;
  const hasTwoLocations = selectedLocations && selectedLocations.length === 2;

  return (
    <FeatureGroup>
      {locations.map(location => {
        const { id: locationId, trackingDevice, lat, lng, name } = location;

        const isSelected = selectedLocations && selectedLocations.includes(locationId);
        const isActive = isSelected || locationId === hoveredId;

        const shouldBeInteractive =
          !disableInteraction &&
          Boolean(validNextLocations.find(validLocation => validLocation.id === locationId));

        const handleSelect = () => {
          if (isSelected) {
            deselectLocation(locationId);
          } else if (!hasTwoLocations) {
            selectLocation(locationId);
          }
          /* you should not be able to select more then two locations */
        };

        return (
          <LocationMarker
            key={`${locationId}`}
            trackingDevice={trackingDevice}
            position={[lat, lng]}
            name={name}
            id={locationId}
            onSelect={shouldBeInteractive ? handleSelect : noop}
            onEnter={
              shouldBeInteractive
                ? () =>
                    enterEntity({
                      id: locationId,
                      type: 'location',
                    })
                : noop
            }
            onLeave={
              shouldBeInteractive
                ? () =>
                    leaveEntity({
                      id: locationId,
                      type: 'location',
                    })
                : noop
            }
            isActive={isActive}
            isFaded={!shouldBeInteractive}
          />
        );
      })}
    </FeatureGroup>
  );
}

LocationMarkerGroup.propTypes = {
  locations: arrayOf(locationShape).isRequired,
  selectLocation: func.isRequired,
  deselectLocation: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  selectedLocations: arrayOf(string),
  currentHover: shape({
    id: string.isRequired,
  }),
  disableInteraction: bool.isRequired,
  validNextLocations: arrayOf(locationShape),
};

const mapStateToProps = ({ map, segmentCreation }) => ({
  currentHover: map.currentHover,
  selectedLocations: segmentCreation.selectedLocations,
});

export default connect(mapStateToProps, {
  ...mapOperations,
  ...segmentCreationOperations,
})(LocationMarkerGroup);



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/LocationMarkerGroup/index.js